exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DashboardPanelAdd-default-11fkw{border:1px dotted #a4b1b7;margin-bottom:30px;padding:40px 0;color:#fff;text-align:center}.DashboardPanelAdd-default-11fkw:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}@media (min-width:768px){.DashboardPanelAdd-default-11fkw{height:276px}}@media (min-width:992px){.DashboardPanelAdd-default-11fkw{height:234.66666667px}}@media (min-width:1200px){.DashboardPanelAdd-default-11fkw{height:288px}}.DashboardPanelAdd-add-1OuYd{display:inline-block;width:80px;height:80px;background:#a4b1b7;border-radius:40px;vertical-align:middle;line-height:1;text-align:center;font-size:80px}.DashboardPanelAdd-clickable-3Z-gC.DashboardPanelAdd-default-11fkw{cursor:pointer}", ""]);

// exports
exports.locals = {
	"default": "DashboardPanelAdd-default-11fkw",
	"add": "DashboardPanelAdd-add-1OuYd",
	"clickable": "DashboardPanelAdd-clickable-3Z-gC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/DashboardPanelAdd.less
// module id = 1644
// module chunks = 0